import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import { ArrowRight, Disc3 } from "lucide-react";

export default function AboutPage() {
  const { t, tp, tpImage } = useApp();
  const tabout = t.about || {};

  const stats = tabout.stats || [
    { k: "2019", v: "Quruluş ili" },
    { k: "5,400+", v: "Vinil arxivi" },
    { k: "180g", v: "Audiofil pres" },
    { k: "AZ · EU · US", v: "İdxal mənbələri" },
  ];

  const principles = tabout.principles || [
    {
      n: "01",
      title: "Kuratorluq",
      body: "Hər vinil mağazaya düşməzdən əvvəl səs, pres və orijinallıq baxımından qiymətləndirilir. Biz miqdara yox, seçimə inanırıq.",
    },
    {
      n: "02",
      title: "Şəffaflıq",
      body: "Mənşə, pres ölkəsi, çəki və vəziyyət hər məhsulun yanında açıq göstərilir. Heç bir gizli detal yoxdur.",
    },
    {
      n: "03",
      title: "Qoruma",
      body: "Hər disk anti-statik qılaf və möhkəm karton qutu ilə paketlənir. Bakı daxilində eyni gün, beynəlxalq isə izlənilən kuryer ilə.",
    },
    {
      n: "04",
      title: "İcma",
      body: "Vinyl Baku sadəcə mağaza deyil — yerli audiofil icmasının görüş nöqtəsidir. Pop-up dinləmə gecələri və mübadilə günləri keçiririk.",
    },
  ];

  const heroImage = tpImage("about", "hero_image_url", "");

  return (
    <div className="bg-[var(--bg)]" data-testid="about-page">
      {/* Hero */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-20">
        <div className="metadata text-[var(--text-muted)] mb-6">{tp("about", "eyebrow", tabout.eyebrow || "VINYL BAKU AZ · 2019—")}</div>
        <h1 className="section-title text-5xl md:text-7xl max-w-4xl leading-[1.02]">
          {tp("about", "title", tabout.title || "Analoq ruh üçün kiçik, lakin diqqətli bir arxiv.")}
        </h1>
        <p className="text-[var(--text-2)] text-lg md:text-xl max-w-2xl mt-8 leading-relaxed">
          {tp("about", "lede",
            tabout.lede ||
            "Vinyl Baku 2019-cu ildə sadə bir fikirlə başladı: şəhərdə dürüst, kurator yanaşması ilə seçilmiş bir vinil məkanı yaratmaq. Bu gün biz Bakının audiofil icması üçün nadir caz idxallarından modern elektronikaya qədər diqqətlə seçilmiş kataloqu saxlayırıq.")}
        </p>
        {heroImage && (
          <div className="mt-12 aspect-[16/8] overflow-hidden">
            <img src={heroImage} alt="" className="w-full h-full object-cover" />
          </div>
        )}
      </section>

      {/* Stats */}
      <section className="border-y border-[var(--border-soft)]">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4">
          {stats.map((s, i) => (
            <div key={i} className={`py-10 md:py-14 ${i !== 0 ? "md:border-l border-[var(--border-soft)]" : ""}`}>
              <div className="section-title text-3xl md:text-5xl">{s.k}</div>
              <div className="metadata text-[var(--text-muted)] mt-3">{s.v}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Story */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="section-eyebrow mb-4">{tp("about", "story_eyebrow", tabout.storyEyebrow || "HEKAYƏ")}</div>
          <h2 className="section-title text-3xl md:text-4xl">{tp("about", "story_title", tabout.storyTitle || "Bir dükkan deyil. Bir arxiv.")}</h2>
        </div>
        <div className="md:col-span-8 text-[var(--text-2)] text-base md:text-lg leading-relaxed space-y-5">
          <p>{tp("about", "story1", tabout.story1 || "Bakıda audiofil keyfiyyətli, şəffaf mənşəli vinil tapmağın çətin olduğunu gördük. Bu yüzdən kiçik bir kolleksiyadan başlayaraq, ildə cəmi 200-dən az başlığı yenilədiyimiz bir kurator məkan qurduq.")}</p>
          <p>{tp("about", "story2", tabout.story2 || "Bu gün Avropa, ABŞ və Yaponiya presləri ilə işləyir, hər diski şəxsən yoxlayır və yalnız qənaətbəxş nüsxələri rəfə qoyuruq. Eyni zamanda yerli kolleksiyaçılardan ikinci əl nüsxələri də qəbul edirik — hər biri dəqiq vəziyyət qeydi ilə.")}</p>
          <p>{tp("about", "story3", tabout.story3 || "Məqsəd sadədir: vinili layiq olduğu kimi tapmaq, dinləmək və saxlamaq.")}</p>
        </div>
      </section>

      {/* Principles */}
      <section className="border-t border-[var(--border-soft)]">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-20">
          <div className="flex items-end justify-between mb-12">
            <div>
              <div className="section-eyebrow mb-3">{tp("about", "principles_eyebrow", tabout.principlesEyebrow || "PRİNSİPLƏR")}</div>
              <h2 className="section-title text-3xl md:text-5xl">{tp("about", "principles_title", tabout.principlesTitle || "İşə yanaşmamız.")}</h2>
            </div>
            <Disc3 size={32} className="text-[var(--text-muted)] hidden md:block" />
          </div>
          <div className="grid md:grid-cols-2 gap-px bg-[var(--border-soft)]">
            {principles.map((p, i) => (
              <div key={i} className="bg-[var(--bg)] p-8 md:p-10">
                <div className="metadata text-[var(--text-muted)]">{p.n}</div>
                <div className="section-title text-2xl md:text-3xl mt-3">{p.title}</div>
                <p className="text-[var(--text-2)] mt-4 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-screen-2xl mx-auto px-6 md:px-12 py-24 text-center">
        <h2 className="section-title text-4xl md:text-6xl max-w-3xl mx-auto">
          {tp("about", "cta_title", tabout.ctaTitle || "Kataloqumuzu gözdən keçirin.")}
        </h2>
        <Link to="/catalog" className="btn-primary mt-10 inline-flex" data-testid="about-cta">
          {tp("about", "cta_button", tabout.ctaButton || "Kataloqa bax")} <ArrowRight size={16} />
        </Link>
      </section>
    </div>
  );
}
